import { types } from "mobx-state-tree";
import Agent from "./Agents/Agent";

const CurrentUser = types
  .model({
    name: types.optional(types.string, ""),
    companyName: types.optional(types.string, ""),
    agent: types.maybeNull(types.reference(types.late(() => Agent))),
  })
  .actions((self) => ({
    setAgent(agent) {
      self.agent = agent;
    },
    setName(name) {
      self.name = name;
    },
  }));

export default CurrentUser;
